var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"step-nav mx-auto mt-2 mb-0",attrs:{"aria-label":"progress"}},_vm._l((_vm.total),function(n){return _c('li',{key:n,staticClass:"step-nav-item",class:{
            'is-active': n === _vm.active,
            'is-done': n < _vm.active,
        }},[_c('span',{staticClass:"step-dot",attrs:{"aria-current":n === _vm.active ? 'step' : null,"aria-label":n < _vm.active
                ? _vm.$t('stepIndicator.completed', { current: n })
                : _vm.$t('stepIndicator.label', { current: n, total: _vm.total })}},[(n < _vm.active)?_c('b-icon-check',{attrs:{"aria-hidden":"true"}}):[_vm._v(_vm._s(n))]],2)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }